import Timeline from '@mui/lab/Timeline';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import Typography from '@mui/material/Typography';
import {YSThemeStyleRadius} from 'main/utility/AppContextProvider/YSTheme';
import {getColor, getFormattedValue} from 'main/utility/helper/FormatUtil';
import PropTypes from 'prop-types';

const AppTimeline = ({widgetSpec, dataSet}) => {
  const {fields, uimapping} = widgetSpec;
  const {eventTime, eventTitle, eventDetail, timelineColor} = uimapping;
  const fieldMap = Object.fromEntries(
    fields.filter((f) => f.visibility === 'show').map((f) => [f.name, f]),
  );

  return (
    <Timeline>
      {dataSet.map((row, index) => {
        const timeField = fieldMap[eventTime];
        const titleField = fieldMap[eventTitle];
        const detailField = fieldMap[eventDetail];
        const colorField = fieldMap[timelineColor] ?? titleField;

        let match = row[colorField.name];
        const bgColor = getColor(match, colorField.bgcolor);

        return (
          <TimelineItem key={row.id || index}>
            {timeField && (
              <TimelineOppositeContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-end',
                  color: 'text.secondary',
                  typography: 'caption',
                  m: 'auto 0',
                }}
              >
                {getFormattedValue(timeField, row[timeField.name])}
              </TimelineOppositeContent>
            )}

            {/* 2. The Center Line */}
            <TimelineSeparator>
              <TimelineConnector sx={{bgcolor: 'divider', opacity: 0.9}} />
              <TimelineDot
                sx={{
                  bgcolor: bgColor,
                  boxShadow: 'none',
                  borderRadius: `${YSThemeStyleRadius.SHARP}px`,
                  border: 'none',
                  width: 12,
                  height: 12,
                }}
              />
              <TimelineConnector sx={{bgcolor: 'divider', opacity: 0.9}} />
            </TimelineSeparator>

            {/* 3. The Right Side (Status and Notes) */}
            <TimelineContent sx={{py: '12px', px: 2}}>
              {titleField && (
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: 12,
                    color: 'text.primary',
                    textTransform: 'uppercase',
                    letterSpacing: '0.02rem',
                  }}
                >
                  {row[titleField.name]}
                </Typography>
              )}

              {detailField && (
                <Typography
                  sx={{
                    color: 'text.secondary',
                    mt: 1,
                    fontSize: 13,
                    letterSpacing: '0.02rem',
                    lineHeight: 1.6,
                  }}
                >
                  {(detailField, row[detailField.name])}
                </Typography>
              )}
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};

export default AppTimeline;

AppTimeline.propTypes = {
  widgetSpec: PropTypes.object.isRequired,
  dataSet: PropTypes.array,
};
